<div class="agpr-distributionReview">
    <agpr-scroll-panel>
        <div class="agpr-distributionReview-padding-wrapper">
            <agpr-panel
                header="Discover.distribution.confirmation.distributionDetails"
                [toggleable]="false"
            >
                <div class="agpr-distributionReview-distributionDetails">
                    <div class="agpr-distributionReview-distributionDetails-row">
                        <div class="agpr-distributionReview-distributionDetails-row-iconContainer">
                            <span
                                *ngIf="!distribution.subjectLine || headerAssessmentMessages.subjectLine.length <= 0"
                                class="fa-solid"
                                [ngClass]="{
                                    'fa-circle-minus': !distribution.subjectLine,
                                    'fa-circle-check': distribution.subjectLine && headerAssessmentMessages.subjectLine.length <= 0
                                }"
                                aria-describedby="subjectLine_missing_error"
                            ></span>
                            <span
                                *ngIf="distribution.subjectLine && headerAssessmentMessages.subjectLine.length > 0"
                                class="fa-solid fa-circle-exclamation"
                                [agprPopover]="subjectLinePopover"
                                [popoverZIndex]="100000"
                                [popoverStyleClass]="'agpr-distributionReview-distributionDetails-row-iconPopoverStyleClass'"
                                aria-labelledby="subjectLine_suggestions"
                            ></span>
                            <ng-template #subjectLinePopover>
                                <div class="agpr-distributionReview-distributionDetails-row-popover">
                                    <span class="agpr-distributionReview-distributionDetails-row-popover-icon agpr-message-icon fa-regular fa-circle-info"></span>
                                    <div
                                        class="agpr-distributionReview-distributionDetails-row-popover-content"
                                        id="subjectLine_suggestions"
                                    >
                                        <p
                                            *ngFor="let message of headerAssessmentMessages.subjectLine"
                                            class="agpr-distributionReview-distributionDetails-row-popover-content-message"
                                        >
                                            {{ message }}
                                        </p>
                                    </div>
                                </div>
                            </ng-template>
                        </div>
                        <label class="agpr-distributionReview-distributionDetails-row-label">
                            {{ 'Discover.targeting.distribution.header.subjectLine' | localize }}
                        </label>
                        <label *ngIf="distribution.subjectLine" class="agpr-distributionReview-distributionDetails-row-label-updatedText">
                            {{ distribution.subjectLine }}
                        </label>
                        <label
                            *ngIf="!distribution.subjectLine"
                            class="agpr-distributionReview-distributionDetails-row-label-requiredText"
                            id="subjectLine_missing_error"
                        >
                            {{ 'Discover.targeting.distribution.header.errors.hasNoSubjectLine' | localize }}
                        </label>
                    </div>

                    <div class="agpr-distributionReview-distributionDetails-row">
                        <div class="agpr-distributionReview-distributionDetails-row-iconContainer">
                            <span
                                *ngIf="headerAssessmentMessages.previewText.length === 0"
                                class="fa-solid fa-circle-check"
                            ></span>
                            <span
                                *ngIf="headerAssessmentMessages.previewText.length > 0"
                                class="fa-solid fa-circle-exclamation"
                                [agprPopover]="previewTextPopover"
                                [popoverZIndex]="100000"
                                [popoverStyleClass]="'agpr-distributionReview-distributionDetails-row-iconPopoverStyleClass'"
                                aria-labelledby="previewText_suggestions"
                            ></span>
                            <ng-template #previewTextPopover>
                                <div class="agpr-distributionReview-distributionDetails-row-popover">
                                    <span class="agpr-distributionReview-distributionDetails-row-popover-icon agpr-message-icon fa-regular fa-circle-info"></span>
                                    <div
                                        class="agpr-distributionReview-distributionDetails-row-popover-content"
                                        id="previewText_suggestions"
                                    >
                                        <p
                                            *ngFor="let message of headerAssessmentMessages.previewText"
                                            class="agpr-distributionReview-distributionDetails-row-popover-content-message"
                                        >
                                            {{ message }}
                                        </p>
                                    </div>
                                </div>
                            </ng-template>
                        </div>
                        <label class="agpr-distributionReview-distributionDetails-row-label">
                            {{ 'Discover.targeting.distribution.header.previewText' | localize }}
                        </label>
                        <label class="agpr-distributionReview-distributionDetails-row-label-updatedText">
                            {{ distribution.previewText }}
                        </label>
                    </div>

                    <div class="agpr-distributionReview-distributionDetails-row">
                        <div class="agpr-distributionReview-distributionDetails-row-iconContainer">
                            <span
                                *ngIf="!distribution.fromName || headerAssessmentMessages.fromName.length === 0"
                                class="fa-solid"
                                [ngClass]="{
                                    'fa-circle-minus': !distribution.fromName,
                                    'fa-circle-check': distribution.fromName && headerAssessmentMessages.fromName.length <= 0
                                }"
                                aria-describedby="fromName_missing_error"
                            ></span>
                            <span
                                *ngIf="headerAssessmentMessages.fromName.length > 0"
                                class="fa-solid fa-circle-exclamation"
                                [agprPopover]="fromNamePopover"
                                [popoverZIndex]="100000"
                                [popoverStyleClass]="'agpr-distributionReview-distributionDetails-row-iconPopoverStyleClass'"
                                aria-labelledby="fromName_suggestions"
                            ></span>
                            <ng-template #fromNamePopover>
                                <div class="agpr-distributionReview-distributionDetails-row-popover">
                                    <span class="agpr-distributionReview-distributionDetails-row-popover-icon agpr-message-icon fa-regular fa-circle-info"></span>
                                    <div
                                        class="agpr-distributionReview-distributionDetails-row-popover-content"
                                        id="fromName_suggestions"
                                    >
                                        <p
                                            *ngFor="let message of headerAssessmentMessages.fromName"
                                            class="agpr-distributionReview-distributionDetails-row-popover-content-message"
                                        >
                                            {{ message }}
                                        </p>
                                    </div>
                                </div>
                            </ng-template>
                        </div>
                        <label class="agpr-distributionReview-distributionDetails-row-label">
                            {{ 'Discover.distribution.confirmation.distributionDetails.from' | localize }}
                        </label>
                        <label *ngIf="distribution.fromName" class="agpr-distributionReview-distributionDetails-row-label-updatedText">
                            {{ distribution.fromName }}
                        </label>
                        <label
                            *ngIf="!distribution.fromName"
                            class="agpr-distributionReview-distributionDetails-row-label-requiredText"
                            id="fromName_missing_error"
                        >
                            {{ 'Discover.targeting.distribution.header.errors.hasNoFrom' | localize }}
                        </label>
                    </div>

                    <div class="agpr-distributionReview-distributionDetails-row">
                        <div class="agpr-distributionReview-distributionDetails-row-iconContainer">
                            <span
                                *ngIf="!distribution.replyEmail || headerAssessmentMessages.replyEmail.length === 0"
                                class="fa-solid"
                                [ngClass]="{
                                    'fa-circle-minus': !distribution.replyEmail,
                                    'fa-circle-check': distribution.replyEmail && headerAssessmentMessages.replyEmail.length <= 0
                                }"
                                aria-describedby="replyEmail_missing_error"
                            ></span>
                            <span
                                *ngIf="headerAssessmentMessages.replyEmail.length > 0"
                                class="fa-solid fa-circle-exclamation"
                                [agprPopover]="replyEmailPopover"
                                [popoverZIndex]="100000"
                                [popoverStyleClass]="'agpr-distributionReview-distributionDetails-row-iconPopoverStyleClass'"
                                aria-labelledby="replyEmail_suggestions"
                            ></span>
                            <ng-template #replyEmailPopover>
                                <div class="agpr-distributionReview-distributionDetails-row-popover">
                                    <span class="agpr-distributionReview-distributionDetails-row-popover-icon agpr-message-icon fa-regular fa-circle-info"></span>
                                    <div
                                        class="agpr-distributionReview-distributionDetails-row-popover-content"
                                        id="replyEmail_suggestions"
                                    >
                                        <p
                                            *ngFor="let message of headerAssessmentMessages.replyEmail"
                                            class="agpr-distributionReview-distributionDetails-row-popover-content-message"
                                        >
                                            {{ message }}
                                        </p>
                                    </div>
                                </div>
                            </ng-template>
                        </div>
                        <label class="agpr-distributionReview-distributionDetails-row-label">
                            {{ 'Discover.targeting.distribution.header.replyEmail' | localize }}
                        </label>
                        <label *ngIf="distribution.replyEmail" class="agpr-distributionReview-distributionDetails-row-label-updatedText">
                            {{ distribution.replyEmail }}
                        </label>
                        <label
                            *ngIf="!distribution.replyEmail"
                            class="agpr-distributionReview-distributionDetails-row-label-requiredText"
                            id="replyEmail_missing_error"
                        >
                            {{ 'Discover.targeting.distribution.header.errors.hasNoReplyEmail' | localize }}
                        </label>
                    </div>

                    @if(distribution.sendFrom) {
                        <div class="agpr-distributionReview-distributionDetails-row">
                            <div class="agpr-distributionReview-distributionDetails-row-iconContainer">
                                <span
                                    class="fa-solid"
                                    [ngClass]="{
                                        'fa-circle-minus': distribution.sendFrom.requiresReAuthentication,
                                        'fa-circle-check': !distribution.sendFrom.requiresReAuthentication
                                    }"
                                    aria-describedby="fromName_missing_error"
                                ></span>
                            </div>
                            <label class="agpr-distributionReview-distributionDetails-row-label">
                                {{ 'Discover.targeting.distribution.header.sendFrom' | localize }}
                            </label>
                            <div class="agpr-distributionReview-distributionDetails-row-container">
                                <label class="agpr-distributionReview-distributionDetails-row-label-updatedText">
                                    {{distribution.sendFrom.connectionName + ' (' + distribution.sendFrom.connectionEmail + ')  '}}
                                </label>
                                <span
                                    class="fa-solid  agpr-distributionReview-distributionDetails-row-iconContainer"
                                    [ngClass]="{
                                        'fa-circle-minus': distribution.sendFrom.requiresReAuthentication,
                                        'fa-circle-exclamation': !distribution.sendFrom.requiresReAuthentication
                                    }"
                                    [agprPopover]="distribution.sendFrom.requiresReAuthentication ? invalidGrantPopover : sendFromPopover"
                                    [popoverZIndex]="100000"
                                    [popoverStyleClass]="'agpr-distributionReview-distributionDetails-row-iconPopoverStyleClass'"
                                    aria-labelledby="sendFromEmail_suggestions"
                                ></span>
                                <ng-template #sendFromPopover>
                                    <div class="agpr-distributionReview-distributionDetails-row-popover">
                                        <span class="agpr-distributionReview-distributionDetails-row-popover-icon agpr-message-icon fa-regular fa-circle-info"></span>
                                        <div
                                            class="agpr-distributionReview-distributionDetails-row-popover-content"
                                        >
                                            <span>{{'Common.dialog.aiDistributionHeader.sendFrom.popover.text' | localize}}</span>
                                            <ul class="agpr-distributionReview-distributionDetails-row-popover-list">
                                                <li>{{'Common.dialog.aiDistributionHeader.sendFrom.popover.point1' | localize}}</li>
                                                <li>{{'Common.dialog.aiDistributionHeader.sendFrom.popover.point2' | localize}}</li>
                                                <li>{{'Common.dialog.aiDistributionHeader.sendFrom.popover.point3' | localize}}</li>
                                                <li>{{'Common.dialog.aiDistributionHeader.sendFrom.popover.point4' | localize}}</li>
                                            </ul>
                                        </div>
                                    </div>
                                </ng-template>
                                <ng-template #invalidGrantPopover>
                                    <div class="agpr-distributionReview-distributionDetails-row-popover agpr-distributionReview-distributionDetails-row-popover--error">
                                        <span class="agpr-distributionReview-distributionDetails-row-popover-icon agpr-message-icon fa-regular fa-minus-circle"></span>
                                            <div
                                                class="agpr-distributionReview-distributionDetails-row-popover-content"
                                            >
                                            <p>{{'Common.dialog.aiDistributionHeader.sendFrom.popover.reauth.header' | localize}}</p>
                                            <p>{{'Common.dialog.aiDistributionHeader.sendFrom.popover.reauth.text' | localize}}</p>
                                            <agpr-button
                                                [id]="'agpr_aiDistributionHeader_sendFrom_reauth'"
                                                [label]="'Common.dialog.aiDistributionHeader.sendFrom.popover.reauth.link'"
                                                [style]="buttonTypes.link"
                                                (click)="openDataConnectionsWindow()"
                                                [underline]="true"
                                            ></agpr-button>
                                        </div>

                                    </div>
                                </ng-template>
                            </div>
                        </div>
                    }
                </div>
                <agpr-button
                    class="agpr-distributionReview-editButton"
                    [id]="id + '_editDetails'"
                    label="Discover.targeting.distribution.editDetails"
                    ariaDescribedBy="distribution_header_has_error_message"
                    [style]="buttonTypes.tertiary"
                    (click)="openHeaderEditor()"
                ></agpr-button>
                <div
                    *ngIf="!errors.isHeaderValid()"
                    class="sr-only"
                    id="distribution_header_has_error_message"
                >
                    {{ 'Discover.targeting.distribution.header.hasErrorMessage' | localize }}
                </div>
            </agpr-panel>
            <agpr-panel
                header="Distribution Composition"
                [toggleable]="false"
            >
                <div class="agpr-distributionReview-composition">
                    <ng-container *ngIf="compositionErrors.length === 0">
                        <div class="agpr-distributionReview-messageContainer">
                            <span class="agpr-distributionReview-composition-icon fa-solid fa-circle-check" aria-hidden="true"></span>
                            <label>
                                {{ 'Discover.targeting.distribution.composition.noErrors' | localize }}
                            </label>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="compositionErrors.length > 0">
                        <div class="agpr-distributionReview-messageContainer">
                            <span class="agpr-distributionReview-composition-icon fa-solid fa-circle-minus" aria-hidden="true"></span>
                            <label
                                class="agpr-distributionReview-composition-errorText"
                                id="compositionError_sectionLabel"
                            >
                                {{ 'Discover.targeting.distribution.composition.errorMessage' | localize }}
                            </label>
                        </div>
                        <ul
                            class="agpr-distributionReview-composition-errorList"
                            id="composition_error_lst"
                            aria-labelledby="compositionError_sectionLabel"
                            tabindex="-1"
                            agprListKeyboardNavigation
                            listOrientation="horizontal"
                            [focusOnChild]="true"
                            [list]="compositionErrors"
                        >
                            <li *ngFor="let error of compositionErrors">
                                <agpr-button
                                    [style]="buttonTypes.link"
                                    (click)="focusErrorElement(error)"
                                    [attr.aria-label]="error.label | localize"
                                >
                                    <span> {{ error.label | localize }} </span>
                                </agpr-button>
                            </li>
                        </ul>
                    </ng-container>
                </div>
                <agpr-button
                    class="agpr-distributionReview-editButton"
                    [id]="id + '_editComposition'"
                    label="Discover.targeting.distribution.editComposition"
                    [style]="buttonTypes.tertiary"
                    (click)="navigateToComposeStep()"
                ></agpr-button>
            </agpr-panel>

            <!-- Attachments -->
            <agpr-panel
                header="Discover.distribution.attachments"
                [toggleable]="false"
            >
                <div
                    *ngFor="let attachmentString of attachmentStrings"
                    class="agpr-distributionReview-attachment-row"
                >
                    <span>{{ attachmentString }}</span>
                </div>
                <div
                    *ngIf="attachmentStrings.length === 0"
                    class="agpr-distributionReview-attachment-placeholder"
                >
                    {{ 'Discover.fileUpload.noFilePlaceholder' | localize }}
                </div>
                <agpr-button
                    class="agpr-distributionReview-editButton"
                    [id]="id + '_editAttachments'"
                    label="Discover.targeting.distribution.editAttachments"
                    [style]="buttonTypes.tertiary"
                    (click)="navigateToComposeStep()"
                ></agpr-button>
            </agpr-panel>

            <!-- Recipients -->
            <agpr-panel
                header="Discover.distribution.recipients"
                class="agpr-distributionReview-recipients"
                [toggleable]="false"
            >
                <ng-container *ngIf="distribution?.recipientInformation?.total > 0">
                    <div class="agpr-distributionReview-messageContainer">
                        <span class="agpr-distributionReview-composition-icon fa-solid fa-circle-check" aria-hidden="true"></span>
                        <label>
                            {{ 'Discover.targeting.distribution.reviewTab.recipientsAdded' | localize }}
                        </label>
                    </div>
                </ng-container>

                <div
                    *ngIf="distribution?.recipientInformation?.total > 0"
                    class="agpr-distributionReview-recipientContainer"
                >
                    <agpr-recipient-panel
                        [isToggleable]="false"
                        [canEditRecipient]="false"
                        [showHeader]="false"
                        [showExtraPadding]="false"
                    ></agpr-recipient-panel>
                </div>

                <div
                    *ngIf="distribution?.recipientInformation?.total <= 0"
                    class="agpr-distributionReview-messageContainer"
                >
                    <span class="agpr-distributionReview-composition-icon fa-solid fa-circle-minus" aria-hidden="true"></span>
                    <label
                        class="agpr-distributionReview-composition-errorText"
                        [id]="id + '_editRecipients_error'"
                    >
                       {{ 'Discover.targeting.distribution.reviewTab.recipientsRequired' | localize }}
                    </label>
                </div>
                <div class="agpr-distributionReview-quota-message">
                    <agpr-quota-dropdown></agpr-quota-dropdown>
                </div>
                <agpr-button
                    class="agpr-distributionReview-editButton"
                    [id]="id + '_editRecipients'"
                    label="Discover.targeting.distribution.editRecipients"
                    [style]="buttonTypes.tertiary"
                    [ariaDescribedBy]="id + '_editRecipients_error'"
                    (click)="navigateToRecipientStep()"
                ></agpr-button>
            </agpr-panel>

            <!-- Personalizations -->
            <agpr-panel
                header="Discover.distribution.personalizations"
                class="personalization"
                [toggleable]="false"
                [agprLoading]="personalizationLoading"
            >
                <div
                    *ngIf="personalizationTags.length === 0"
                    class="personalization-messageContainer"
                >
                    <span class="agpr-distributionReview-composition-icon fa-solid fa-circle-exclamation" aria-hidden="true"></span>
                    <label>
                        {{ 'Discover.targeting.distribution.reviewTab.noPersonalizations' | localize }}
                    </label>
                </div>

                <div class="personalization-promo">
                    <div class="personalization-promo-Row">
                        <div class="personalization-promo-Col">
                            <span class="personalization-promo-bold">
                                {{ 'Discover.targeting.distribution.reviewTab.personalizationPromo.header' | localize }}
                            </span>
                            <span>
                                {{ 'Discover.targeting.distribution.reviewTab.personalizationPromo.header2' | localize }}
                            </span>
                        </div>
                        <agpr-button
                            class="personalization-promo-button"
                            [icon]="collapsed ? 'fa-solid fa-angle-down' : 'fa-solid fa-angle-up'"
                            [style]="buttonTypes.icon"
                            [attr.aria-label]="collapsed ? 'Collapsed' : 'Expanded'"
                            (click)="toggle($event)"
                        ></agpr-button>
                    </div>
                    <div
                        #panelContentWrapper
                        [@panelContent]="collapsed ? 'hidden' : 'visible'"
                        (@panelContent.done)="animating = false"
                        [ngClass]="{'personalization-promo-overflow': collapsed||animating}"
                        [attr.role]="'region'"
                        [attr.aria-hidden]="collapsed"
                        [attr.aria-labelledby]="'distributionReview_editRecipients_label'"
                    >
                        <div class="personalization-promo-body">
                            <ul>
                                <li> {{ 'Discover.targeting.distribution.reviewTab.personalizationPromo.bullet1' | localize }} </li>
                                <li> {{ 'Discover.targeting.distribution.reviewTab.personalizationPromo.bullet2' | localize }} </li>
                                <li> {{ 'Discover.targeting.distribution.reviewTab.personalizationPromo.bullet3' | localize }} </li>
                                <li> {{ 'Discover.targeting.distribution.reviewTab.personalizationPromo.bullet4' | localize }} </li>
                            </ul>
                            <agpr-button
                                label="Discover.targeting.distribution.reviewTab.personalizationPromo.learnMore"
                                (click)="learnMore()"
                                [style]="buttonTypes.primary"
                            ></agpr-button>
                        </div>
                    </div>
                </div>
                <ng-container *ngIf="unlockedSearches">
                    <agpr-message
                        [id]="id + '_unlockedSearchesBanner'"
                        class="personalization-infoBanner"
                        [severity]="messageSeverityEnum.warning"
                        [bottomMargin]="false"
                    >
                        <span> {{ 'Discover.targeting.distribution.reviewTab.personalization.unlockedSearchBanner' | localize }} </span>
                        <agpr-button
                            class="personalization-infoBanner-link"
                            [id]="id + '_editRecipients'"
                            label="Discover.targeting.distribution.editRecipients"
                            [style]="buttonTypes.link"
                            (click)="navigateToRecipientStep()"
                        ></agpr-button>
                    </agpr-message>
                    <div
                        *ngIf="distribution.id"
                        class="personalization-includeSearch"
                    >
                        <agpr-checkbox
                            [id]="id + '_includeSearchCount'"
                            label="Discover.targeting.distribution.reviewTab.personalization.includeSearchCount"
                            [(ngModel)]="includeSavedSearch"
                            (ngModelChange)="personalizationService.getUnsavedSearchSummary(includeSavedSearch)"
                            [binary]="true"
                        ></agpr-checkbox>
                        <span class="personalization-includeSearch-estimate"> {{ 'Discover.targeting.distribution.reviewTab.personalization.includeSearchCount.estimate' | localize }} </span>
                    </div>
                </ng-container>

                <div class="personalization-cardContainer">
                    <ng-container *ngFor="let summary of personalizationSummary">
                        <agpr-personalization-detail-card
                            [label]="'Discover.personalizationTag.' + summary.tagType"
                            [value]="summary.totalPersonalizations"
                            [maxValue]="summary.totalRecipients"
                            [estimate]="includeSavedSearch"
                            [color]=""
                        ></agpr-personalization-detail-card>
                    </ng-container>
                </div>

                <agpr-button
                    *ngIf="personalizationTags.length === 0"
                    class="personalization-button"
                    [id]="id + '_editComposition'"
                    label="Discover.targeting.distribution.editComposition"
                    [style]="buttonTypes.tertiary"
                    (click)="navigateToComposeStep()"
                ></agpr-button>
                <agpr-button
                    *ngIf="personalizationTags.length > 0"
                    class="personalization-button"
                    [id]="id + '_personalize'"
                    label="Discover.targeting.distribution.personalize"
                    [style]="buttonTypes.tertiary"
                    (click)="navigateToPersonalizeStep()"
                ></agpr-button>
            </agpr-panel>
        </div>
    </agpr-scroll-panel>
</div>
